export const mobileStepsAnim = (
  progress: number,
  {
    imgRef,
    bgRef,
    notificationImgRef,
    contentRef,
    deviceRef,
  }: {
    imgRef: React.MutableRefObject<HTMLDivElement | null>;
    bgRef: React.MutableRefObject<HTMLDivElement | null>;
    notificationImgRef: React.MutableRefObject<HTMLDivElement | null>;
    contentRef: React.MutableRefObject<HTMLDivElement | null>;
    deviceRef: React.MutableRefObject<HTMLDivElement | null>;
  },
) => {
  if (
    !imgRef.current ||
    !bgRef.current ||
    !notificationImgRef.current ||
    !contentRef.current ||
    !deviceRef.current
  ) {
    return;
  }
  if (progress < 0.2) {
    deviceRef.current.style.opacity = '1';
    notificationImgRef.current.style.opacity = `0`;
    imgRef.current.style.opacity = `0`;
    bgRef.current.style.opacity = `1`;
    contentRef.current.style.opacity = `0`;
    return;
  }
  if (progress < 0.25) {
    deviceRef.current.style.opacity = '1';
    notificationImgRef.current.style.opacity = `${
      (progress - 0.2) / (0.25 - 0.2)
    }`;
    notificationImgRef.current.style.transform = `scale(${Math.min(
      1,
      0.5 + (progress - 0.2) / (0.25 - 0.2),
    )})`;
    imgRef.current.style.opacity = `0`;
    bgRef.current.style.opacity = `1`;
    contentRef.current.style.opacity = `0`;
    return;
  }
  if (progress < 0.3) {
    deviceRef.current.style.opacity = '1';
    notificationImgRef.current.style.opacity = '1';
    notificationImgRef.current.style.transform = `none`;
    imgRef.current.style.opacity = `0`;
    bgRef.current.style.opacity = `1`;
    contentRef.current.style.opacity = `0`;
    return;
  }
  if (progress < 0.35) {
    notificationImgRef.current.style.opacity = `${
      1 - (progress - 0.3) / (0.35 - 0.3)
    }`;
    notificationImgRef.current.style.transform = `scale(${Math.max(
      0,
      1 - (progress - 0.3) / (0.35 - 0.3) / 2,
    )})`;
    imgRef.current.style.opacity = `0`;
    bgRef.current.style.opacity = `${
      1 - ((progress - 0.3) * 3) / (0.35 - 0.3)
    }`;
    deviceRef.current.style.opacity = `${
      0.2 + 1 - (progress - 0.3) / (0.35 - 0.3)
    }`;
    contentRef.current.style.opacity = `${(progress - 0.3) / (0.35 - 0.3)}`;
    return;
  }
  bgRef.current.style.opacity = '0';
  notificationImgRef.current.style.opacity = `0`;
  imgRef.current.style.opacity = `${(progress - 0.35) / (0.6 - 0.35)}`;
  deviceRef.current.style.opacity = `${0.2 + (progress - 0.35) * (0.6 - 0.35)}`;
  contentRef.current.style.opacity = `${
    1 - ((progress - 0.35) / (0.6 - 0.35)) * 2
  }`;
};
